@if (unconfirmedTicket) {
  <div class="ts-info-root-div">
    <patron-form
      [formGroup]="formGroup"
      role="form"
      class="form-horizontal h-100"
      (onSubmit)="sendDetail()">
      <div class="card pt-2 px-3 mb-0">
        <patron-textarea
          [formGroup]="formGroup"
          formControlName="observation"
          label="Informações"
          [rows]="infoTextareaRows"
          [includeBR]="false"
          (focus)="onInfoTextareaFocus()"
          (blur)="onInfoTextareaBlur()">
        </patron-textarea>
        <div class="row">
          <div class="col-6">
            <patron-form-check [inputTemplate]="input" [labelTemplate]="label">
              <ng-template #input>
                <input type="checkbox" id="isPublic" formControlName="isPublic" />
              </ng-template>
              <ng-template #label>
                <label for="isPublic">Público</label>
              </ng-template>
            </patron-form-check>
          </div>
          <div class="col-6 flex justify-content-end">
            <patron-button type="submit" [disabled]="isSaving === true"> Enviar </patron-button>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-auto py-4">
          @if (loadingMovimentHistories) {
            <patron-spinner size="lg"></patron-spinner>
          }
        </div>
      </div>
      <div class="col-12 d-flex justify-content-end align-items-center flex-wrap gap-2">
        <div
          class="btn-group btn-group-sm mr-2"
          role="group"
          aria-label="Alternar visualização das informações">
          <button
            type="button"
            class="btn"
            [class.btn-primary]="showDetailsAsMarkdown"
            [class.btn-outline-primary]="!showDetailsAsMarkdown"
            (click)="setDetailsViewMode('markdown')">
            <i class="bi bi-markdown mr-1"></i>
            Markdown
          </button>
          <button
            type="button"
            class="btn"
            [class.btn-primary]="!showDetailsAsMarkdown"
            [class.btn-outline-primary]="showDetailsAsMarkdown"
            (click)="setDetailsViewMode('text')">
            <i class="bi bi-text-left mr-1"></i>
            Texto
          </button>
        </div>
        <div class="d-flex justify-content-end flex-wrap">
          <button
            class="btn btn-sm rounded-circle mr-1"
            type="button"
            title="públicas"
            [ngClass]="{
              'btn-primary': ticketService.showPublicDetails,
              'btn-light': !ticketService.showPublicDetails,
            }"
            (click)="
              ticketService.showPublicDetails = !ticketService.showPublicDetails;
              ticketService.setFilterLocalStorage(
                'showPublicDetails',
                ticketService.showPublicDetails
              )
            ">
            <i class="bi-globe-americas"></i>
          </button>
          <button
            class="btn btn-sm rounded-circle mr-1"
            type="button"
            title="privadas"
            [ngClass]="{
              'btn-primary': ticketService.showPrivateDetails,
              'btn-light': !ticketService.showPrivateDetails,
            }"
            (click)="
              ticketService.showPrivateDetails = !ticketService.showPrivateDetails;
              ticketService.setFilterLocalStorage(
                'showPrivateDetails',
                ticketService.showPrivateDetails
              )
            ">
            <i class="bi-lock-fill"></i>
          </button>
          <button
            class="btn btn-sm rounded-circle mr-1"
            type="button"
            title="apontamentos"
            [ngClass]="{
              'btn-primary': ticketService.showLogs,
              'btn-light': !ticketService.showLogs,
            }"
            (click)="
              ticketService.showLogs = !ticketService.showLogs;
              ticketService.setFilterLocalStorage('showLogs', ticketService.showLogs)
            ">
            <i class="bi-clock-fill"></i>
          </button>
          <button
            class="btn btn-sm rounded-circle"
            type="button"
            title="histórico"
            [ngClass]="{
              'btn-primary': ticketService.showMovementHistory,
              'btn-light': !ticketService.showMovementHistory,
            }"
            (click)="
              ticketService.showMovementHistory = !ticketService.showMovementHistory;
              ticketService.setFilterLocalStorage(
                'showMovementHistory',
                ticketService.showMovementHistory
              )
            ">
            <i class="bi-clock-history"></i>
          </button>
        </div>
      </div>
      @for (detail of timeline; track detail) {
        @if (
          (detail.type === 'D' && detail.pub && ticketService.showPublicDetails) ||
          (detail.type === 'D' && !detail.pub && ticketService.showPrivateDetails) ||
          (detail.type === 'L' && ticketService.showLogs) ||
          ((detail.type === 'MH' || detail.type === 'DMH') && ticketService.showMovementHistory)
        ) {
          <div class="detail d-flex row no-gutters">
            <div class="col-2 pr-1 py-2">
              <div class="detail-date text-center mt-1">
                <div class="text-uppercase">
                  <small
                    ><b>{{ detail.start_date || detail.created_at | date: 'EEEE' }}</b></small
                  >
                </div>
                <div>
                  {{ detail.start_date || detail.created_at | date: 'd MMM, yy' }}
                </div>
                <div class="">
                  {{ detail.start_date || detail.created_at | date: 'HH:mm' }}
                </div>
              </div>
            </div>
            <div class="col-1 pr-1 py-2">
              <div class="mt-3 h-100 text-center">
                <button class="btn btn-sm rounded-circle btn-secondary">
                  <i [class]="getTimelineIcon(detail)"></i>
                </button>
                <div class="vertical-line"></div>
              </div>
            </div>
            <div class="col-9 py-2">
              <div class="card surface-ground h-100">
                <div class="card-body py-1">
                  <small class="">{{ detail?.user?.name || detail?.user?.login }}</small>
                  <div class="detail-obs">
                    @if (detail.startDate) {
                      <div>
                        <b>{{ detail.startDate | date: 'HH:mm' }}</b> Apontamento iniciado
                      </div>
                    }
                    @if (detail.description) {
                      <div class="my-1 detail-description">
                        @if (showDetailsAsMarkdown) {
                          <markdown [data]="detail.description"></markdown>
                        } @else {
                          <span class="detail-description-text">{{ detail.description }}</span>
                        }
                      </div>
                    }
                    @if (detail.endDate) {
                      <div>
                        <b>{{ detail.endDate | date: 'HH:mm' }}</b> Apontamento finalizado <br />
                        Duração: {{ detail.startDate | ticketLogTime: detail.endDate }}
                      </div>
                    }
                  </div>
                </div>
                @if (detail.images && detail.images.length) {
                  <div class="card-footer">
                    <div class="image-container">
                      @for (image of detail.images; track image) {
                        <div class="image-item">
                          <img
                            [src]="image"
                            alt="Detail Image"
                            class="img-fluid my-2 fixed-height"
                            (click)="openImageModal(image)" />
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
    </patron-form>
  </div>
}

<patron-modal
  [visible]="imageModalVisible"
  size="xl"
  id="info-image"
  [backdrop]="'static'"
  (cancel)="closeImageModal()"
  (visibleChanged)="!$event && closeImageModal()"
  class="image-modal">
  <div class="image-modal-content">
    <img [src]="selectedImage" class="large-image" />
  </div>
</patron-modal>
